module.exports = __webpack_public_path__ + "img/Play.911f537f.svg";